import Vue from 'vue'
import VueRouter from 'vue-router'

import routes from './routes'

Vue.use(VueRouter)

const router = new VueRouter({
  routes,
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    // } else if (to.hash) {
    //   console.log('okkk')
    //   return { x: 100, y: 100 }
    } else {
      return {
        x: 0,
        y: 0,
      }
    }
  },
})

router.beforeEach((to, from, next) => {
  next()
})

export default router
